var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.clicked}}),_c('form-servizio-clienti',{attrs:{"showPrivacy":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }